import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './DogePuddle.css';
import api from '../utils/api';
import { io } from 'socket.io-client';

const DogePuddle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [prizePool, setPrizePool] = useState(0);
  const [messageCount, setMessageCount] = useState(0);
  const [topMessage, setTopMessage] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  useEffect(() => {
    // Load initial prize pool
    loadPrizePool();

    // Connect to Socket.IO for real-time updates
    const socket = io(API_URL);
    
    socket.on('prize:pool:update', (data) => {
      setIsAnimating(true);
      setPrizePool(data.prize_pool);
      setMessageCount(data.message_count);
      setTimeout(() => setIsAnimating(false), 500);
      // Reload to get updated top message
      loadPrizePool();
    });

    return () => {
      socket.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [API_URL]);

  const loadPrizePool = async () => {
    try {
      const response = await api.get('/api/pool/daily');
      setPrizePool(response.data.prize_pool);
      setMessageCount(response.data.message_count);
      setTopMessage(response.data.top_message);
    } catch (error) {
      console.error('Error loading prize pool:', error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const isStandalonePage = location.pathname === '/pool';

  return (
    <div className={isStandalonePage ? 'puddle-page-container' : 'doge-puddle-container'}>
      {isStandalonePage && (
        <div className="navigation-bar win98-bevel-inset">
          <div className="nav-links">
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
              💬 Chat
            </Link>
            <Link to="/pool" className={`nav-link ${location.pathname === '/pool' ? 'active' : ''}`}>
              <img src="/doge.png" alt="Doge" style={{ height: '16px', width: 'auto', verticalAlign: 'middle', marginRight: '4px' }} /> Pool
            </Link>
            <Link to="/leaderboard" className={`nav-link ${location.pathname === '/leaderboard' ? 'active' : ''}`}>
              🏆 Leaderboard
            </Link>
            <Link to="/settings" className={`nav-link ${location.pathname === '/settings' ? 'active' : ''}`}>
              ⚙️ Settings
            </Link>
            <Link to="/faq" className={`nav-link ${location.pathname === '/faq' ? 'active' : ''}`}>
              ❓ FAQ
            </Link>
            <Link to="/tos" className={`nav-link ${location.pathname === '/tos' ? 'active' : ''}`}>
              📜 Rules/ToS
            </Link>
            <a 
              href="https://discord.gg/B26JbHZsqq" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="nav-link discord-link"
              title="Join our Discord"
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <svg width="16" height="16" viewBox="0 0 71 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0824 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0824 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 49.9718 48.5383C51.038 50.6034 52.2554 52.5699 53.5951 54.435C53.651 54.5139 53.7489 54.5477 53.8413 54.5195C59.646 52.7249 65.5286 50.0174 71.6015 45.5576C71.6551 45.5182 71.6887 45.459 71.6943 45.3942C73.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.2991 34.8216 17.2991 31.6709C17.2991 28.5203 20.1717 26.0166 23.7259 26.0166C27.308 26.0166 30.1626 28.4935 30.1526 31.6709C30.1426 34.8483 27.308 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.8911 34.8216 40.8911 31.6709C40.8911 28.5203 43.7636 26.0166 47.3178 26.0166C50.9 26.0166 53.7545 28.4935 53.7446 31.6709C53.7346 34.8483 50.9 37.3253 47.3178 37.3253Z" fill="#5865F2"/>
              </svg>
              Discord
            </a>
          </div>
        </div>
      )}

      <div className={`doge-puddle-container ${isStandalonePage ? 'win98-bevel' : ''}`}>
        <div className="puddle-header">
          <h3 className="puddle-title">
            <img src="/doge.png" alt="Doge" className="doge-inline-image" /> Doge Pool <img src="/doge.png" alt="Doge" className="doge-inline-image" />
          </h3>
          <p className="puddle-subtitle">Daily Prize Pool</p>
        </div>
        
        <div className={`puddle-content ${isAnimating ? 'pulse' : ''}`}>
          <div className="puddle-visual">
            <div className="puddle-shape">
              <img src="/dogecoin-logo.png" alt="Dogecoin" onError={(e) => {
                console.error('Failed to load dogecoin-logo.png, falling back to doge.png');
                e.target.src = '/doge.png';
              }} />
            </div>
          </div>
          
          <div className="puddle-stats">
            <div className="stat-item">
              <span className="stat-label">Prize Pool:</span>
              <span className="stat-value prize">{prizePool.toFixed(2)} DOGE</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Messages Today:</span>
              <span className="stat-value">{messageCount}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Total Pool:</span>
              <span className="stat-value highlight">100% Distributed</span>
            </div>
          </div>
        </div>

        {topMessage && (
          <div className="top-message-section win98-bevel-inset">
            <h4 className="top-message-title">🏆 Current Leader</h4>
            <div className="top-message-content">
              <div className="top-message-header">
                <span 
                  className="top-message-username clickable"
                  onClick={() => navigate(`/user/${topMessage.user_id}`)}
                  title="View profile"
                >
                  👤 {topMessage.username}
                </span>
                <span className="top-message-upvotes">⬆️ {topMessage.upvote_count} upvotes</span>
              </div>
              <div className="top-message-text">{topMessage.content}</div>
              <div className="top-message-time">{formatDate(topMessage.created_at)}</div>
            </div>
          </div>
        )}

        {!topMessage && messageCount > 0 && (
          <div className="no-leader-section win98-bevel-inset">
            <p>No upvotes yet today. Be the first to get upvoted! <img src="/doge.png" alt="Doge" className="doge-inline-image" /></p>
          </div>
        )}

        {messageCount === 0 && (
          <div className="no-messages-section win98-bevel-inset">
            <p>No messages today yet. Start the puddle growing! <img src="/doge.png" alt="Doge" className="doge-inline-image" /></p>
          </div>
        )}

        <div className="puddle-footer">
          <p>🏆 Top 3 most upvoted messages win prizes at midnight UTC! See FAQ for reward breakdown.</p>
        </div>
      </div>
    </div>
  );
};

export default DogePuddle;

